import React, { useEffect, useState } from "react";
import "./ExtendedModal.scss";
import CLOSE_ICON from "../../Images/closed.png";
import Dropdown from "../common/Dropdown";
import { ButtonModule as Button } from "../common/Button";
import { Grid } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api_call from "../../globals/common_utilities/axios_old";
import { API, STATUS, ROLE, APP_ROUTES } from "../../globals/constants/index";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import Cookies from "universal-cookie";
import Close from "../../Images/closed.png";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";

const ExtendedModal = (props) => {
  const { closeModal, ExtendedTraining, training_id, training_date_id } = props;
  const [cancelReason, setCancelReason] = useState();
  const [min, setMin] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hours, setHours] = useState([
    {
      id: "15 Min",
      label: "15 Min",
      name: "15 Min",
      value: "15",
    },
    {
      id: "30 Min",
      label: "30 Min",
      name: "30 Min",
      value: "30",
    },
    {
      id: "45 Min",
      label: "45 Min",
      name: "45 Min",
      value: "45",
    },
    {
      id: "1hr 0min",
      label: "1hr 0min",
      name: "1hr 0min",
      value: "60",
    },
    {
      id: "1hr 15min",
      label: "1hr 15min",
      name: "1hr 15min",
      value: "75",
    },
    {
      id: "1hr 30min",
      label: "1hr 30min",
      name: "1hr 30min",
      value: "90",
    },
    {
      id: "1hr 45min",
      label: "1hr 45min",
      name: "1hr 45min",
      value: "105",
    },
    {
      id: "2hr 0min",
      label: "2hr 0min",
      name: "2hr 0min",
      value: "120",
    },
    {
      id: "2hr 15min",
      label: "2hr 15min",
      name: "2hr 15min",
      value: "135",
    },
    {
      id: "2hr 30min",
      label: "2hr 30min",
      name: "2hr 30min",
      value: "150",
    },
    {
      id: "2hr 45min",
      label: "2hr 45min",
      name: "2hr 45min",
      value: "165",
    },
    {
      id: "3hr 0min",
      label: "3hr 0min",
      name: "3hr 0min",
      value: "180",
    },
    {
      id: "3hr 15min",
      label: "3hr 15min",
      name: "3hr 15min",
      value: "195",
    },
    {
      id: "3hr 30min",
      label: "3hr 30min",
      name: "3hr 30min",
      value: "210",
    },
    {
      id: "3hr 45min",
      label: "3hr 45min",
      name: "3hr 45min",
      value: "225",
    },
    {
      id: "4hr 0min",
      label: "4hr 0min",
      name: "4hr 0min",
      value: "240",
    },
    {
      id: "4hr 15min",
      label: "4hr 15min",
      name: "4hr 15min",
      value: "255",
    },
    {
      id: "4hr 30min",
      label: "4hr 30min",
      name: "4hr 30min",
      value: "270",
    },
    {
      id: "4hr 45min",
      label: "4hr 45min",
      name: "4hr 45min",
      value: "285",
    },
    {
      id: "5hr 0min",
      label: "5hr 0min",
      name: "5hr 0min",
      value: "300",
    },
    {
      id: "5hr 15min",
      label: "5hr 15min",
      name: "5hr 15min",
      value: "315",
    },
    {
      id: "5hr 15min",
      label: "5hr 15min",
      name: "5hr 15min",
      value: "330",
    },
    {
      id: "5hr 30min",
      label: "5hr 30min",
      name: "5hr 30min",
      value: "345",
    },
    {
      id: "5hr 45min",
      label: "5hr 45min",
      name: "5hr 45min",
      value: "360",
    },
    {
      id: "6hr 0min",
      label: "6hr 0min",
      name: "6hr 0min",
      value: "375",
    },
  ]);
  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");
  const ExtendTraining = async () => {
    if (min !== "") {
      let queryParam = {
        unique_id: id,
      };
      setIsLoading(true);
      const response = await api_call(
        "post",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.EXTEND_SERVER
        }`,
        queryParam,
        {},
        {
          min: min?.value,
          training_id: training_id,
          training_date_id: training_date_id,
        }
      );
      if (response.status === 200) {
        setIsLoading(false);
        toast.success("Session Extended Successfully", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return closeModal();
      } else {
        setIsLoading(false);
        toast.error(`${response.err.data.msg1}`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" }
        });
        return closeModal();
      }
    } else {
      toast.error("please select time from dropdown", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" }
      });
    }
  };
  return (
    <div id="extendedModal" className="extended-Modal">
      <div className="extended-Modal-content">
        <button className="close_button medium_f" onClick={closeModal}>
          X
        </button>
        <h3>Extend Training</h3>
        <p>
          Extend session by selecting the time from the dropdown and then click
          on confirm.
        </p>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <p className="hours_selection">Select Time</p>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
            <Dropdown
              placeholder="Select time"
              options={hours}
              isMulti={false}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              onChange={(selected) => setMin(selected)}
              allowSelectAll={true}
              value={min}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={9} lg={9} xl={9}></Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <div className="extended_button_div">
              <button
                className="extend_button medium_f"
                onClick={() => ExtendTraining()}
              >
                Confirm
              </button>
            </div>
          </Grid>
        </Grid>
      </div>
      {isLoading && <MultiLine_Spinner />}
    </div>
  );
};

export default ExtendedModal;
